import React from "react";
import { ToastContainer } from "react-toastify";

const Ledger = ({ rows = [], currentPage, itemsPerPage }) => {
  return (
    <>
    <ToastContainer/>

    <div className="overflow-x-auto montserrat-font-1">
      <table className="min-w-full border border-gray-200 montserrat-font-1">
        <thead className="bg-green-500 text-white montserrat-font-1">
          <tr className="text-center">
            <th className="p-3">S.No</th>
            <th className="p-3">Date</th>
            <th className="p-3">Opening Balance</th>
            <th className="p-3">Closing Balance</th>
            <th className="p-3">Today Topup</th>
            <th className="p-3">Today Refund</th>
            <th className="p-3">Payout Today</th>
            <th className="p-3">Settlement Today</th>
            <th className="p-3">Last Transaction</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center py-6">
                No Ledger Records Found
              </td>
            </tr>
          ) : (
            rows.map((r, index) => (
              <tr key={index} className="border-b text-center">
                <td className="p-3">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>

                <td className="p-3">{r.datevalue}</td>
                <td className="p-3">₹ {r.opening_bal}</td>
                <td className="p-3">₹ {r.closing_bal}</td>
                <td className="p-3">₹ {r.today_topup}</td>
                <td className="p-3">₹ {r.today_refund}</td>
                <td className="p-3">₹ {r.payout_today}</td>
                <td className="p-3">₹ {r.settlement_today}</td>
                <td className="p-3">{r.last_transaction || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
    </>
  );
};

export default Ledger;
